import React from "react";
import { AnimatePresence, motion } from "framer-motion";

const LoadingAnimation = ({ isLoading, message = "Loading..." }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          key="loading-screen"
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.02 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            background: "rgba(17, 33, 56, 0.96)",
            color: "#fff",
          }}
        >
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            style={{ fontSize: 32, fontWeight: 600 }}
          >
            Welcome to Virbix 3D Fusion
          </motion.div>
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            style={{ fontSize: 14, opacity: 0.8 }}
          >
            {message}
          </motion.div>
          <motion.div
            initial={{ rotate: 0, opacity: 0 }}
            animate={{ rotate: 360, opacity: 1 }}
            transition={{
              delay: 0.9,
              opacity: { duration: 0.3 },
              rotate: { duration: 1, repeat: Infinity, ease: "linear" },
            }}
            style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              border: "3px solid rgba(255,255,255,0.2)",
              borderTopColor: "#fff",
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoadingAnimation;
